import "./LessonsMaterial.css";

import { Material } from "../../../model/model";
import React from "react";
import { lessonActions } from "../../../store/slices/lessonSlice";
import { useAppDispatch } from "../../../store";

interface Props {
  material: Material[];
}
export default function LessonsMaterial(props: Props) {
  const { material } = props;
  const dispatch = useAppDispatch();

  const onClick = (m: Material) => {
    dispatch(lessonActions.setMaterial(m));
  };

  return (
    <div className="lessons-material support-column">
      <h4 className="support-title">
        Hjálparefni Lóu
        <span className="support-subtitle">Support Material</span>
      </h4>
      <ul>
        {material.map((m) => (
          <li key={m.uid} className={`material file-${m.type}`}>
            <button className="loa-link-button" onClick={() => onClick(m)}>
              <span className="file-name">{m.name}</span>
            </button>
            <span className="file-description">{m.description}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
